const LINE_BOUNDS = "M0 0L0 0M16 16L16 16";

export const CHART_LEGEND_ICONS = {
  rect: "rect",
  line: `path://${LINE_BOUNDS}M0 7H16V9H0Z`,
  dashed: `path://${LINE_BOUNDS}M0 7H6V9H0Z M10 7H16V9H10Z`,
  dotted: `path://${LINE_BOUNDS}M0 7H2V9H0Z M5 7H7V9H5Z M9 7H11V9H9Z M14 7H16V9H14Z`,
} as const;

export function chartLegendEntry(name: string, kind: keyof typeof CHART_LEGEND_ICONS) {
  return { name, icon: CHART_LEGEND_ICONS[kind] };
}